import {createReducer} from "redux-act";
import {fetchGamesJSON, fetchGamesJSONSuccess} from "apps/BUDWEISERPOTM/modules/actions";
import {RequestState} from "modules";

interface IGamesReducer {
	games: ReturnType<typeof fetchGamesJSONSuccess>["payload"];
	requestState: RequestState;
}

const initial: IGamesReducer = {
	games: [],
	requestState: RequestState.IDLE,
};

export const games = createReducer<IGamesReducer>({}, initial)
	.on(fetchGamesJSON, (state, roundId) => ({
		...state,
		requestState: RequestState.Requested,
	}))
	.on(fetchGamesJSONSuccess, (state, payload) => ({
		...state,
		games: payload,
		requestState: RequestState.Received,
	}));
